export default __webpack_public_path__ + "ui/assets/img/cockpit-logo.svg";